import xhttp from 'src/utils/xhttp'
import { formHeader } from 'src/utils/form-data'

const component = {
    /**
     * 注册组件
     *
     * @param comp
     * @returns Promise
     */
    create(comp) {
        return xhttp.post('/api/dev/components', comp)
    },

    /**
     * 更新组件
     *
     * @param comp
     * @returns Promise
     */
    update(comp) {
        return xhttp.put(`/api/dev/component/${comp.id}`, comp)
    },

    /**
     * 组件详情
     *
     * @param componentId
     * @returns Promise
     */
    detail(componentId) {
        return xhttp.get(`/api/dev/component/${componentId}`)
    },

    /**
     * 组件详情
     *
     * @param componentId
     * @returns Promise
     */
    list(params) {
        return xhttp.get('/api/dev/components', { params })
    },

    /**
     * 删除组件
     *
     * @param componentId
     * @returns Promise
     */
    delete(componentId) {
        return xhttp.delete(`/api/dev/component/${componentId}`)
    },

    /**
     * 刷新组件
     *
     * @param componentVersionId
     * @returns Promise
     */
    refresh(componentVersionId) {
        return xhttp.put(`/api/dev/component/${componentVersionId}/refresh`)
    },

    /**
     * 组件版本列表
     *
     * @param componentId
     * @returns Promise
     */
    versionList({ componentId, ...params }) {
        return xhttp.get(`/api/dev/component/${componentId}/version`, { params })
    },

    /**
     * 增加一个组件的版本
     *
     * @param componentId
     * @returns Promise
     */
    addVersion(params) {
        return xhttp.post('/api/dev/components/versions', params)
    },

    /**
     * 删除组件版本
     *
     * @param {*} componentVersionId
     */
    deleteVersion(componentVersionId) {
        return xhttp.delete(`/api/dev/components/versions/${componentVersionId}`)
    },

    /**
     * 获取分支、tag列表
     * @param gitUrl
     * @returns {Promise<AxiosResponse.data>}
     */
    getBranchAndTagList(gitUrl) {
        return xhttp.get(`/api/dev/repo/branch-tag-list?gitUrl=${gitUrl}`)
    },

    /**
     * @param  {} componentId 组件id
     * @param  {} componentVersionId 组件版本id
     * @param  {} params client，zone
     */
    editComponentVersion(componentId, componentVersionId, params) {
        return xhttp.post(
            `/api/dev/component/${componentId}/version/${componentVersionId}/edit`,
            params
        )
    },

    /**
     * 获取组件包列表
     *
     * @param {number} page
     * @param {number} pageSize
     * @param {string} name
     * @returns
     */
    getPackageList(params) {
        return xhttp.get('/api/dev/component-packages', { params })
    },

    /**
     * 删除组件包
     *
     * @param {string}  packageId
     * @returns
     */
    deletePackage(packageId) {
        return xhttp.delete(`/api/dev/component-package/${packageId}`)
    },

    /**
     * 添加组件包
     *
     * @param {file}    package
     * @param {string}  remark
     * @returns
     */
    addPackage(params) {
        return xhttp.post('/api/dev/component-package', params, formHeader)
    },

    /**
     * 从git拉取组件包
     * @param params
     * @returns {AxiosPromise<any>}
     */
    addPackageFromGit(params) {
        return xhttp.post('/api/dev/component-package/git', params)
    },

    /**
     * 刷新组件包（git）
     * @param packageVersionId
     */
    retryPackageFromGit(params) {
        const { packageId, packageVersionId } = params
        return xhttp.put(
            `/api/dev/component-package/${packageId}/version/${packageVersionId}/retry`,
            params
        )
    },
    /**
    * 刷新组件包（上传）
    * @param packageVersionId
    */
    refreshPackage(packageVersionId) {
        return xhttp.put(`/api/dev/component-package/${packageVersionId}/refresh`)
    },


    /**
     * 添加组件包版本
     *
     * @param {string}      packageId
     * @param {FormData}    data
     * @param {file}        data.package
     * @param {string}      data.remark
     * @param {string}      data.version
     * @returns
     */
    addPackageVersion(params) {
        const { packageId, data } = params
        return xhttp.post(`/api/dev/component-package/${packageId}/version`, data, formHeader)
    },

    /**
     * 通过git添加组件包版本
     * @param params
     * @returns {AxiosPromise<any>}
     */
    addPackageVersionFromGit(params) {
        const { packageId, data } = params
        return xhttp.post(`/api/dev/component-package/${packageId}/version/git`, data)
    },

    /**
     * 获取组件包版本列表
     * @param params
     * @returns {*}
     */
    getPackageVersion(params) {
        const { packageId, ...other } = params
        return xhttp.get(`/api/dev/component-package/${packageId}/versions`, { params: other })
    },

    /**
     * 获取组件包详情
     *
     * @param {string} packageId
     */
    getPackageDetail(packageId) {
        return xhttp.get(`/api/dev/component-package/${packageId}`)
    },

    /**
     * 获取组件包最新版本
     *
     * @param {string} packageId
     */
    getPackageLatestVersion(packageId) {
        return xhttp.get(`/api/dev/component-package/${packageId}/latest-version`)
    },

    /**
     * 删除组件包版本
     *
     * @param {string} packageId
     * @param {string} versionId
     * @param {string} version
     * @returns
     */
    deletePackageVersion(params) {
        const { packageId, versionId, version } = params
        return xhttp.delete(`/api/dev/component-package/${packageId}/version/${versionId}`, {
            version
        })
    },

    /**
     * 获取组件解析日志
     *
     * @param {string}  buildId
     * @param {string}  preLogId
     * @returns
     */
    getPackageVersionLogs({ buildId, preLogId }) {
        return xhttp.get(`/api/dev/build-logs/${buildId}`, { params: { preLogId } })
    },

    /**
     * 获取组件依赖列表
     *
     * @param {string}  type
     * @returns
     */
    getComponentDepsList(componentVersionId, params) {
        return xhttp.get(`/api/dev/component/${componentVersionId}/get-dependence-list`, { params })
    },

    /**
     * 编辑组件的依赖保存
     *
     * @param {string}  type
     * @returns
     */
    saveComponentDeps(params) {
        return xhttp.post('/api/dev/component/dependence/edit', params)
    },

    /**
    * 编辑组件的引擎范围保存
    *
    * @param {string}  id
    * @param {string}  isPackage
    * @param {string}  min_engine_ver
    * @param {string}  max_engine_ver
    * @returns
    */
    saveComponentEngineScope(params) {
        return xhttp.post('/api/dev/component/edit-engine', params)
    },
}

export default component
